import { useState } from 'react';

interface FormData {
  phone: string;
  email: string;
  password: string;
  name: string;
  referralCode?: string;
}

interface AccountFormProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: string) => void;
  className?: string;
}

export function AccountForm({ formData, onFormChange, className = '' }: AccountFormProps) {
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (field: keyof FormData, value: string) => {
    if (field === 'phone') {
      value = value.replace(/[^0-9]/g, '');
    }
    onFormChange(field, value);
  };

  return (
    <div className={`space-y-6 ${className}`}>
      {/* 휴대폰 번호 입력 */}
      <div>
        <label className="block text-[18px] font-medium text-[#222222] mb-3">
          휴대폰번호 <span className="text-red-500">*</span>
        </label>
        <input
          type="tel"
          value={formData.phone}
          onChange={(e) => handleInputChange('phone', e.target.value)}
          placeholder="휴대폰번호 입력 ('-' 없이 숫자만)"
          className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#86DB89] placeholder:text-[#979797] transition-colors"
        />
      </div>

      {/* 이메일 입력 */}
      <div>
        <label className="block text-[18px] font-medium text-[#222222] mb-3">
          이메일 <span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          value={formData.email}
          onChange={(e) => handleInputChange('email', e.target.value)}
          placeholder="이메일 입력"
          className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#86DB89] placeholder:text-[#979797] transition-colors"
        />
      </div>

      {/* 비밀번호 입력 */}
      <div>
        <label className="block text-[18px] font-medium text-[#222222] mb-3">
          비밀번호 <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <input
            type={showPassword ? 'text' : 'password'}
            value={formData.password}
            onChange={(e) => handleInputChange('password', e.target.value)}
            placeholder="영문, 숫자 조합 8자리 이상"
            className="w-full h-[48px] px-5 pr-14 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#86DB89] placeholder:text-[#979797] transition-colors"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-5 top-1/2 -translate-y-1/2"
          >
            <img
              src="/icons/icon_eye.svg"
              alt={showPassword ? '비밀번호 숨기기' : '비밀번호 보기'}
              className="w-6 h-6 opacity-60"
            />
          </button>
        </div>
        {formData.password && formData.password.length < 8 && (
          <p className="text-red-500 text-[14px] mt-2">8자리 이상 입력해주세요</p>
        )}
      </div>

      {/* 이름 입력 */}
      <div>
        <label className="block text-[18px] font-medium text-[#222222] mb-3">
          이름 <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => handleInputChange('name', e.target.value)}
          placeholder="이름 입력"
          className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#86DB89] placeholder:text-[#979797] transition-colors"
        />
      </div>

      {/* 추천인 코드 입력 (선택사항) */}
      <div>
        <label className="block text-[18px] font-medium text-[#222222] mb-3">
          추천인 코드 <span className="text-[#666666] text-[16px]">(선택사항)</span>
        </label>
        <input
          type="text"
          value={formData.referralCode || ''}
          onChange={(e) => handleInputChange('referralCode', e.target.value)}
          placeholder="추천인 코드 입력"
          className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#86DB89] placeholder:text-[#979797] transition-colors"
        />
      </div>
    </div>
  );
}